import { render, staticRenderFns } from "./RestorationMaintenanceNotice.vue?vue&type=template&id=03489c8a"
import script from "./RestorationMaintenanceNotice.vue?vue&type=script&lang=js"
export * from "./RestorationMaintenanceNotice.vue?vue&type=script&lang=js"
import style0 from "./RestorationMaintenanceNotice.vue?vue&type=style&index=0&id=03489c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports